<template lang="pug">
  #signUpIndex.d-flex.flex-column(
    style="height: calc(100% - 120px)"
  )
    .container-width.w-100(
      style="padding-bottom: 20px;flex: 1 1 0;",
    )
      #step1(v-if="nowStep == 1")
        .mb-4.font-weight-bold.text-center
          p.d-block.mb-0 誠摯邀請您註冊 TIFFANY & CO. 官方帳號
          p.d-block.mb-0 優先獲得 TIFFANY & CO. 的最新資訊
        .mb-2.bg-gray-light.p-3
          small.d-block.mb-0 TIFFANY & CO. LINE官方帳號的相關査詢及註冊服務係由TIFFANY & CO. 執行，進行驗證時，TIFFANY & CO. 將根據您提供的姓名及行動電話與LINE帳號進行身分驗證。成功完成註冊後，若日後更換手機或重新安裝LINE APP，需以原本LINE ID重新登入，以利繼續使用。
          small.d-block.mb-0 為了提供您更好的服務與產品訊息，現邀請您提供姓名、手機號碼等個人資料，TIFFANY & CO. 將蒐集、利用及處理您所提供之個人資料於客戶管理與服務、產品行銷、業務推廣與廣告等目的。同時您所提供之資料，亦可能會提供予TIFFANY & CO. 於中華民國境内或境外之關係企業或合作夥伴。TIFFANY & CO. 就您所提供之資料一律保密;若TIFFANY & CO. 將您的資料提供給關係企業或合作夥伴，亦會要求其等負保密義務。TIFFANY & CO. 、TIFFANY & CO. 關係企業及合作夥伴將於其國內或國外之所在地以電話、書面或其他方式利用您的個人資料。您有權自由選擇是否提供個人資料，若您所提供之資料有誤或不完整，可能會影響您享有TIFFANY & CO. 提供的服務及最新資訊。依實際作業需要，TIFFANY & CO. 可能會不時補充、更正或刪除相關資料。原則上，若您未要求刪除，TIFFANY & CO. 將於法令許可之期間內利用及保留您所提供的資料。您有權查詢或請求閲覽、製給複製本、補充或更正、停止蒐集、處理或利用及刪除您所提供的任何資料。請審閲我們的全球隱私政策條款https://www.zh.tiffany.com/policy/privacy-policy，該全球隱私政策包含TIFFANY & CO. 如何與您通訊及使用您資訊的重要内容。
        .font-weight-bold.text-center
          p.mb-0 聯絡我們 0800-028628
          p.mb-0 (星期一至星期五 早上9:30至晚上6:30)
        hr.border-primary
        b-form-checkbox.text-center.font-weight-bold.mb-3(
          id="agree"
          v-model="agree_status"
          name="agree"
          :value="true"
          :unchecked-value="false"
        ) 我已詳閱並同意相關使用須知
      #step2(v-if="nowStep == 2")
        p.text-center.pt-3 輸入個人資料
        hr.border-primary.border-width-lg.w-100
        .text-center
          p.text-center 立即綁定摯友即可下載專屬主題桌布
          small.d-block.w-100.p-3 請輸入姓名、行動電話及居住地區完成設定，若您曾於TIFFANY & CO. 留存個人資料，請輸入相同資料。
        b-card.border-0.my-4(
          bg-variant="white"
        )
          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required",
                ref="inputValName"
              )
                .row.justify-content-center.mb-4
                  .col-10
                    b-form-input(
                      id="lastName",
                      type="text",
                      required,
                      trim,
                      :state="validState('lastName')",
                      v-model="userForm.lastName",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入姓",
                      class="rounded-0 bg-light border-black text-center"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 此欄不可為空
                .row.justify-content-center.mb-4
                  .col-10
                    b-form-input(
                      id="firstName",
                      type="text",
                      required,
                      trim,
                      :state="validState('firstName')",
                      v-model="userForm.firstName",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入名",
                      class="rounded-0 bg-light border-black text-center"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 此欄不可為空
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                .row.justify-content-center.mb-4
                  .col-10
                    .row.no-gutters
                      .col-5
                        b-form-select(
                          id="store",
                          required,
                          v-model="userForm.area_code",
                          :state="validState('area_code')",
                          aria-describedby="input-live-help input-name-live-feedback",
                          placeholder="請選擇區碼",
                          class="rounded-0 bg-light border-black text-center border-right-0"
                        )
                          template(
                            v-slot:first
                          )
                            b-form-select-option(
                              :value="null",
                              disabled
                            ) 請選擇區碼
                          b-form-select-option(
                            v-for="(area_code,index) in areaCodeOption",
                            :key="index",
                            :value="area_code.id"
                          ) {{ `(${area_code.label})${area_code.name}` }}
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}
                      .col-7
                        b-form-input(
                          id="mobile",
                          type="tel",
                          required,
                          trim,
                          :state="validState('mobile')",
                          v-model="userForm.mobile",
                          aria-describedby="input-live-help input-name-live-feedback",
                          placeholder="請輸入行動電話",
                          class="rounded-0 bg-light border-black text-center"
                        )
                        b-form-invalid-feedback(
                          id="input-name-live-feedback"
                        )
                          span {{ errors[0] }}
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                .row.justify-content-center.mb-4
                  .col-10
                    b-form-select(
                      id="store",
                      required,
                      v-model="userForm.live_area",
                      :state="validState('live_area')",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請選擇居住區域",
                      class="rounded-0 bg-light border-black text-center"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                        ) 請選擇居住區域
                      b-form-select-option(
                        v-for="(live_area,index) in liveAreaOption",
                        :key="live_area.name",
                        :value="live_area.name"
                      ) {{ live_area.name }}
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}
            b-form-group(
              class="mb-0"
              v-if="!sa_id && !store_id"
            )
              ValidationProvider(
                rules="required",
                ref="inputValMobile",
                v-slot="{ errors }"
              )
                .row.justify-content-center.mb-4
                  .col-10
                    b-form-select(
                      id="store",
                      required,
                      v-model="userForm.store_reference",
                      :state="validState('store_reference')",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請選擇喜好專門店",
                      class="rounded-0 bg-light border-black text-center"
                    )
                      template(
                        v-slot:first
                      )
                        b-form-select-option(
                          :value="null",
                          disabled
                        ) 請選擇喜好專門店
                      b-form-select-option(
                        v-for="(store,index) in storeDropdown",
                        :key="store.title",
                        :value="store.id"
                      ) {{ store.title }}
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span {{ errors[0] }}
            b-form-group(
              class="mb-0"
            )
              ValidationProvider(
                rules="required|verify",
                ref="inputValVerify",
                v-slot="{ errors }"
              )
                .row.justify-content-center.mb-4
                  .col-10
                    .row.no-gutters
                      .col-md-8.col-6.pr-1.d-flex.align-items-center.flex-wrap
                        b-form-input.w-100(
                          id="verify",
                          type="text",
                          required,
                          trim,
                          :state="validState('verify')",
                          v-model="userForm.verify",
                          aria-describedby="input-live-help input-name-live-feedback",
                          placeholder="請輸入驗證碼",
                          class="rounded-0 bg-light border-black text-center"
                        )
                        b-form-invalid-feedback.w-100(
                          id="input-name-live-feedback"
                        )
                          span {{ errors.length === 0 ? '驗證碼錯誤' : errors[0] }}
                      .col-md-4.col-6.pl-1
                        .d-flex.align-items-center.justify-content-between
                          VerifyComponent(
                            ref="VerifyComponent"
                          )
                          i.fas.fa-sync-alt.fa-lg(
                            @click="changeVerifyCodeHandler"
                          )
      #step3(v-if="nowStep == 3")
        p.mb-0.text-center.py-3.letter-spacing-6 請輸入發送至您手機之驗證碼
        hr.border-primary.border-width-lg.w-100
        b-card.border-0.mb-2(
          bg-variant="white"
        )
          ValidationObserver(
            ref="mobileVerfityForm"
            tag="form"
            @submit.stop.prevent="mobileVerfityHandler"
          )
            .row.justify-content-center.mb-4
              .col-10
                b-form-group.mb-0
                  ValidationProvider(
                    rules="required",
                    ref="inputValMobileVerfity"
                  )
                    b-form-input(
                      id="mobileVerfity",
                      type="text",
                      required,
                      trim,
                      :state="validverfityState()",
                      v-model="mobileVerfityCode",
                      aria-describedby="input-live-help input-name-live-feedback",
                      placeholder="請輸入驗證碼",
                      class="rounded-0 bg-light border-black text-center mb-3"
                    )
                    b-form-invalid-feedback(
                      id="input-name-live-feedback"
                    )
                      span 簡訊驗證碼不可為空
                  .text-center
                    div(
                      v-if="verfityNowTime == 0"
                    )
                      button.btn.btn-remind.rounded-50.mt-2(
                        type="button",
                        @click="countDownHandler",
                        class="rounded-0 bg-light border-black text-center text-black btn-block"
                      )
                        i.fas.fa-redo.fa-md.arrorIcon.pr-1
                        span 重發驗證碼
                    div(
                      v-else
                    )
                      span.font-weight-bold {{ verfityNowTime }}
                      | 秒後可重發驗證碼
    .footer.bg-white.w-100.pb-4
      b-button(
        variant="primary",
        block,
        @click="nextStepHandler()",
        class="rounded-0 text-black border-gray"
      ) 確認
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import { M_SIGN_UP_SUCCESS, M_SIGN_UP_ACTIVITY } from '@/router/member/sign-up';
import area_code from '@/helper/JSON/area_code.json';
const _ = require('lodash');

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SignUpIndex',
  components: {
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  props: {
    sa_id: {
      type: [String, Number],
      required: false
    },
    store_id: {
      type: [String, Number],
      required: false
    },
    ecmid: {
      type: [String, Number],
      required: false
    },
    source: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        lastName: null,
        firstName: null,
        area_code: null,
        mobile: null,
        live_area: null,
        verify: null,
        store_reference: null
      },
      mobileVerfityCode: null,
      verfityTotalTime: 60,
      verfityNowTime: 0,
      verfityCanClick: true,
      areaCodeOption: area_code,
      liveAreaOption: [
        {
          name: '北部區域'
        },
        {
          name: '中部區域'
        },
        {
          name: '南部區域'
        },
        {
          name: '東部區域'
        },
        {
          name: '海外區域'
        }
      ],
      line_uuid: '',
    };
  },
  mounted() {

    const vm = this;

    const queryString = window.location.search.split('?directBy=')[1];
    if (queryString === 'sticker' || vm.$route.params.directBy === 'sticker') {
      window.sessionStorage.setItem('directBy', 'sticker');
      vm.$store.commit('member_sign_up/setRedirectPage', queryString || vm.$route.params.directBy);
    }

    // 檢查綁定狀態
    vm.$store.dispatch('member_sign_up/checkMemberBindHandler')
    // vm.$store.dispatch('member_sign_up/checkBindingHandler')
      .then((res) => {
        vm.line_uuid = res.line_uuid;
        window.sessionStorage.setItem('line_uuid', vm.line_uuid);
        const input = {
          loginChannelId: process.env.VUE_APP_LINE_LOGIN_CHANNEL_ID,
          msgChannelId: process.env.VUE_APP_LINE_MESSAGE_CHANNEL_ID
        };
        const query = Object.keys(input).reduce(function(a, k){
          a.push(k + '=' + encodeURIComponent(input[k]));
          return a;
        }, []).join('&');
        if (res.type === 'unbind_member') { // 已綁定摯友但未綁定CA
          vm.$router.push({
            name: 'm-bind-sa-recommend',
            params: {
              line_uuid: res.line_uuid
            }
          })
        } else if (res.type === 'bind_member') { // 摯友且已有CA
          vm.$store.dispatch('member_sign_up/getOneToOneInfoHandler')
            .then((res)=>{
              window.location.href = `https://line.me/R/oaMessage/${process.env.VUE_APP_LINE_BOT_ID}/?${res.data}`;
            })
        } else if (res.type === 'personnel') { // CA
          vm.$store.commit('toggleLoading', false);
          vm.$swal.fire({
            icon: 'info',
            title: 'LINE帳號已綁定「CA」，請勿重覆綁定'
          })
            .then(() => {
              window.sessionStorage.clear();
              window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
              return;
            })
        } else {
          if (vm.ecmid) {
            vm.$store.dispatch('member_sign_up/fastBindingCheckHandler', { ecmid: vm.ecmid });
          }
          vm.$store.dispatch('member_sign_up/getStoreDropdownHandler', query).then(() => {
            if (vm.sa_id && vm.store_id) {
              vm.userForm.store_reference = vm.store_id;
            }
            vm.$store.commit('toggleLoading', false);
          });
        }
      });
  },
  methods: {
    nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        if (!vm.agree_status) {
          this.$swal.fire({
            icon: 'info',
            title: '請勾選同意事項'
          });
        } else {
          if (vm.ecmid) {
            vm.$store.dispatch('member_sign_up/fastBindingHandler', { ecmid: vm.ecmid}).then((res) => {
              vm.$router.push({
                name: M_SIGN_UP_SUCCESS,
                params: {
                  ecmFastBinding: true
                }
              });
            }).catch((err) => {
            });
          } else {
            vm.nowStep = 2;
          }
        }
        break;
      case '2':
        vm.submitHandler();
        break;
      case '3':
        vm.mobileVerfityHandler();
        break;
      default:
        break;
      }
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.userForm.validate();
      if (!isValid) {
        if (vm.userForm.lastName === null) {
          vm.userForm.lastName = '';
        }
        if (vm.userForm.firstName === null) {
          vm.userForm.firstName = '';
        }
        if (vm.userForm.area_code === null) {
          vm.userForm.area_code = '';
        }
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (vm.userForm.live_area === null) {
          vm.userForm.live_area = '';
        }
        if (vm.userForm.verify === null) {
          vm.userForm.verify = '';
        }
        if (vm.userForm.verify === null) {
          vm.userForm.store_reference = '';
        }
        this.$swal.fire({
          icon: 'info',
          title: '請填妥必填欄位'
        });
      } else {
        // 因為客製化驗證 extend 可以判斷是不是輸入一樣驗證碼但抓不到值，
        // 會造成畫面顯示正確卻一直跳到 isValid，所以改成手動驗證。
        if (vm.userForm.verify !== vm.$refs.VerifyComponent.varifyAnswer) {
          this.$swal.fire({
            icon: 'info',
            title: '請填妥必填欄位'
          });
          return;
        }
        if (!vm.validState('mobile')) {
          this.$swal.fire({
            icon: 'info',
            title: '手機號碼格式錯誤，請重新確認'
          });
          return;
        }
        vm.countDownHandler();
        vm.nowStep = 3;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await this.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.mobileVerfityCode === null) {
          vm.mobileVerfityCode = '';
        }
        vm.$swal.fire({
          icon: 'info',
          title: '請填寫驗證碼'
        });
      } else {
        vm.$swal.fire({
          title: '請稍候，\n表單送出中',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });

        const validateInfo = {
          last_name: vm.userForm.lastName,
          first_name: vm.userForm.firstName,
          area_code: vm.userForm.area_code,
          mobile: vm.userForm.mobile,
          area: vm.userForm.live_area,
          code: vm.mobileVerfityCode,
          act: vm.$route.params.act || null,
        };

        if (vm.sa_id && vm.store_id) {
          validateInfo.sa_id = vm.sa_id;
          validateInfo.store_id = vm.store_id;
        }

        if ((vm.userForm.store_reference !== null || vm.userForm.store_reference !== '') && (vm.store_id === null || vm.store_id === '' || vm.store_id === undefined)) {
          validateInfo.store_reference = vm.userForm.store_reference;
        }

        // 送出並綁定
        vm.$store.dispatch('member_sign_up/validateSmsAndBindingHandler', validateInfo)
          .then(() => {
            this.$swal.close();
            // 優先處理特殊活動來源
            if (vm.source) {
              vm.$router.push({
                name: M_SIGN_UP_ACTIVITY,
                params: {
                  ...vm.$route.params,
                  line_uuid: vm.line_uuid
                }
              })
              return;
            }
            if (vm.sa_id && vm.store_id) {
              vm.$router.push({
                name: M_SIGN_UP_SUCCESS,
                params: {
                  singUpAndBindSa: true,
                  line_uuid: vm.line_uuid
                }
              });
            } else {
              // 原本導頁到綁定成功頁 改為導頁到桌布頁
              vm.$router.push({
                name: M_SIGN_UP_SUCCESS,
                params: {
                  singUpAndBindSa: true,
                  line_uuid: vm.line_uuid
                }
              });
            }
          });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        if (key === 'mobile') {
          const MobileReg = /^09\d{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'verify') {
          return vm.userForm.verify === vm.$refs.VerifyComponent.varifyAnswer ? true : false;
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      if (!vm.verfityCanClick) return;
      // 發送驗證碼
      vm.$store.dispatch('member_sign_up/sendSmsValidateHandler', {
        area_code: vm.userForm.area_code,
        mobile: vm.userForm.mobile
      })
        .then(() => {
          vm.$snotify.success(null, '驗證碼已寄出');
          vm.verfityCanClick = false;
          vm.verfityNowTime = vm.verfityTotalTime;
          const clock = window.setInterval(() => {
            if (vm.verfityNowTime === 0) {
              window.clearInterval(clock);
              vm.verfityCanClick = true; // 這裡重新開啟
            } else {
              vm.verfityNowTime -= 1;
            }
          }, 1000);
        });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    }
  },
  computed: {
    ...mapState({
      storeDropdown: (state) => state.member_sign_up.storeDropdown
    })
  }
};
</script>

<style>

</style>
